import React from 'react';
import { api } from '@/lib/api';

interface State { hasError: boolean; error?: Error }

export class ErrorBoundary extends React.Component<{ children: React.ReactNode }, State> {
  state: State = { hasError: false };

  static getDerivedStateFromError(error: Error): State {
    return { hasError: true, error };
  }

  componentDidCatch(error: Error, info: React.ErrorInfo) {
    void api.post('/anomalies/report', {
      source: 'CLIENT',
      severity: 'ERROR',
      title: 'Erreur de rendu React',
      message: error.message,
      stack: error.stack,
      route: window.location.pathname,
      context: { componentStack: info.componentStack },
    }).catch(() => {});
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="p-8 text-center">
          <h2 className="text-lg font-bold text-red-600 mb-2">Erreur de rendu</h2>
          <pre className="text-xs text-left bg-red-50 border border-red-200 rounded p-4 max-w-2xl mx-auto overflow-auto">
            {this.state.error?.message}
            {'\n'}
            {this.state.error?.stack}
          </pre>
        </div>
      );
    }
    return this.props.children;
  }
}
